import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryGrid = ({ categories, onCategorySelect }) => {
  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary-100 text-primary hover:bg-primary-200',
      secondary: 'bg-secondary-100 text-secondary hover:bg-secondary-200',
      success: 'bg-success-100 text-success hover:bg-success-200',
      warning: 'bg-warning-100 text-warning hover:bg-warning-200',
      info: 'bg-info-100 text-info hover:bg-info-200',
      danger: 'bg-danger-100 text-danger hover:bg-danger-200'
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl text-text-primary mb-4">
            Browse Help Categories
          </h2>
          <p className="text-lg text-text-secondary">
            Find answers organized by topic
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories?.map((category) => (
            <div
              key={category?.id}
              onClick={() => onCategorySelect?.(category?.id)}
              className="bg-white border border-border rounded-xl p-6 cursor-pointer hover:shadow-medium transition-all duration-200 group"
            >
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-colors ${getColorClasses(category?.color)}`}>
                  <Icon name={category?.icon} size={24} />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-lg text-text-primary mb-2 group-hover:text-primary transition-colors">
                    {category?.title}
                  </h3>
                  <p className="text-text-secondary text-sm mb-3">
                    {category?.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-text-muted text-xs">
                      {category?.articleCount} articles
                    </span>
                    <Icon 
                      name="ArrowRight" 
                      size={16} 
                      className="text-text-muted group-hover:text-primary transition-colors" 
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;